<template>
    <div class="spage">
        <p @click="resetTag" class="reset">{{ $t('productList.reset') }}</p>
        <div class="tagList" style="display:flex;justify-content: space-between;">
            <div style="max-width:80%">
                <el-tag v-show="allTagShow" :hit='false' closable :disable-transitions="false" @close="handleCloseAllTag">
                    {{ $t('productList.all') }}
                </el-tag>
                <div v-for='(item, index) in producstTypeSubCategoryList' :key="index" style="float:left;">
                    <el-tag :key="item.id" color='#fff' :hit='false' closable :disable-transitions="false"
                        @close="handleCloseProduct(item)">
                        {{ item.label }}
                    </el-tag>
                </div>
                <div v-for='(item, index) in otherList' :key='index + "-only"' style="float:left;margin-bottom:10px">
                    <el-tag :key="item.id" color='#fff' :hit='false' closable :disable-transitions="false"
                        @close="handleCloseFilter(item)">
                        {{ item.label }}
                    </el-tag>
                </div>
                <div style="float:left;">
                    <el-tag color='#fff' :hit='false' closable :disable-transitions="false"
                        @close="handleClear($store.state.search)" v-show='$store.state.search.checked'>
                        {{ $store.state.search.history }}
                    </el-tag>
                </div>
                <div style="clear:both"></div>
            </div>
            <div style="white-space: nowrap;" class="result">
                {{ $t('productList.resultText') }}({{ $store.state.total }}{{ $t('productList.resultText2') }})
            </div>
        </div>
        <div>
            <div class="hidden-appdeatils">
                <div class="list hidden-apps-down">
                    <ul>
                        <li v-for='(items, idx) in $store.state.fpageData' :key="idx">
                            <BrickItem :data='items'></BrickItem>
                        </li>
                    </ul>
                </div>
                <div class="list-sm hidden-apps-up">
                    <ul>
                        <li v-for='(items, idx) in $store.state.fpageData' :key="idx">
                            <BrickItem :data='items'></BrickItem>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hidden-mobileapps list-mobile">
                <ul>
                    <li v-for='(items, idx) in $store.state.fpageData' :key="idx">
                        <BrickItem :data='items'></BrickItem>
                    </li>
                </ul>
            </div>
        </div>
        <div style="text-align:center">
            <el-pagination background layout="prev, pager, next" :total="total" :current-page='pageIndex'
                @next-click='nextClick' @prev-click='prevClick' @current-change='currentPage' :page-size='pageSize'>
            </el-pagination>
        </div>
    </div>
</template>

<script>
import BrickItem from '@/components/Brick'

export default {
    name: 'ProductFPage',
    components: {
        BrickItem
    },
    computed: {
        producstTypeSubCategoryList() {
            const list = []
            this.$store.state.productTypeList.forEach(m => {
                const subList = m.subCategoryList.filter(n => this.$store.state.subCategoryId.includes(n.id))
                list.push(...subList)
            })
            return list
        },
        otherList() {
            const list = []
            this.$store.state.filterList.forEach(m => {
                const filterList = m.subCategoryList.filter(n => this.$store.state.otherId.includes(n.id))
                list.push(...filterList)
            })
            return list
        },
        allTagShow() {
            return !!this.$store.state.checkedAllCategoryId
        },
        pageIndex: {
            get() {
                return this.$store.state.pageIndex
            },
            set(v) {
                this.$store.commit('changePageIndex', v)
            }
        },
        pageSize: {
            get() {
                return this.$store.state.pageSize
            },
            set(v) {
                this.$store.commit('changePageSize', v)
            }
        },
        total: {
            get() {
                return this.$store.state.total
            },
            set(v) {
                this.$store.commit('changeTotal', v)
            }
        }
    },
    data: () => {
        return {
            array: []
        }
    },
    methods: {
        handleCloseAllTag() {
            this.$store.commit('clearCheckedAllCategoryId')
            this.checkedData({})
        },
        //点击选择框
        checkedData(data) {
            this.$store.commit('addSubCategoryId', data.id);
            if (this.$store.state.checkedAllCategoryId || this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0 || this.$store.state.search['checked']) {
                this.$router.push({
                    name: 'ProductFPage',
                    query: {
                        subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
                        search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
                        otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
                        categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum,
                    }
                })
                this.$store.dispatch('getProductDataList')
            } else {
                var id = this.$store.state.activeNum
                this.$store.dispatch('getHotProductList');
                this.$router.push({ name: 'ProductSPage', params: { cname: id } })
            }
        },
        resetTag() {
            this.clearTagList()
            this.$router.push({ name: 'ProductIndex' });
        },
        handleCloseProduct(tag) {
            this.$store.commit('addSubCategoryId', tag.id);
            this.$store.commit('changePageIndex', 1);
            if (this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0 || this.$store.state.search['checked']) {
                this.$router.push({
                    name: 'ProductFPage',
                    query: {
                        subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
                        search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
                        otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
                        categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum,
                    }
                })
                this.$store.dispatch('getProductDataList');
            } else {
                var id = this.$store.state.activeNum;
                this.$store.dispatch('getHotProductList');
                this.$router.push({ name: 'ProductSPage', params: { cname: id } })
            }
        },
        handleCloseFilter(tag) {
            this.$store.commit('addOtherId', tag.id);
            this.$store.commit('changePageIndex', 1);
            if (this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0 || this.$store.state.search['checked']) {
                this.$router.push({
                    name: 'ProductFPage',
                    query: {
                        subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
                        search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
                        otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
                        categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum
                    }
                })
                this.$store.dispatch('getProductDataList');
            } else if (this.$store.state.activeNum != '') {
                this.$store.dispatch('getHotProductList');
                this.$router.push({ name: 'ProductSPage', params: { cname: this.$store.state.activeNum } })
            } else {
                // this.$store.commit('changePage', 3);
                this.$router.push({
                    name: 'ProductIndex',
                });
            }
        },
        handleClear(tag) {
            tag.checked = false;
            this.$store.commit('getSearchhistory', '');
            this.$store.commit('changePageIndex', 1);
            if (this.$store.state.subCategoryId.length > 0 || this.$store.state.otherId.length > 0 || this.$store.state.search['checked']) {
                this.$router.push({
                    name: 'ProductFPage',
                    query: {
                        subCategoryIds: this.$store.state.subCategoryId.length === 0 ? undefined : this.$store.state.subCategoryId,
                        search: this.$store.state.search['history'] == "" ? undefined : this.$store.state.search['history'],
                        otherId: this.$store.state.otherId.length === 0 ? undefined : this.$store.state.otherId,
                        categoryId: this.$store.state.activeNum == "" ? undefined : this.$store.state.activeNum
                    }
                })
                this.$store.dispatch('getProductDataList');
            } else if (this.$store.state.activeNum != '') {
                this.$store.dispatch('getHotProductList');
                this.$router.push({ name: 'ProductSPage', params: { cname: this.$store.state.activeNum } });
            } else {
                this.$router.push({
                    name: 'ProductIndex'
                })
            }
        },
        nextClick: function (num) {
            this.$store.commit('changePageIndex', num);
            this.$store.dispatch('getProductDataList')
            // chrome
            document.body.scrollTop = 0
            // firefox
            document.documentElement.scrollTop = 0
            // safari
            window.pageYOffset = 0
        },
        prevClick: function (num) {
            this.$store.commit('changePageIndex', num);
            this.$store.dispatch('getProductDataList');
            // chrome
            document.body.scrollTop = 0
            // firefox
            document.documentElement.scrollTop = 0
            // safari
            window.pageYOffset = 0
        },
        currentPage: function (num) {
            this.$store.commit('changePageIndex', num);
            this.$store.dispatch('getProductDataList');
            // chrome
            document.body.scrollTop = 0
            // firefox
            document.documentElement.scrollTop = 0
            // safari
            window.pageYOffset = 0
        },
        clearTagList() {
            this.$store.commit('changeCheckedState', false);
            this.$store.commit('changeFilterIdCheckedState', false);
            this.$store.commit('clearSubcategoryId', true);
            this.$store.commit('clearOtherId', true);
            this.$store.commit('getSearchhistory', '');
            this.$store.commit('handleChange', '');
            this.$store.commit('showSearchTag', false);
        },
        getFistState() {
            this.clearTagList();
            if (this.$route.query.subCategoryIds || this.$route.query.otherId || this.$route.query.search) {
                if (this.$route.query.subCategoryIds) {
                    this.$store.commit('handleChange', this.$route.query.categoryId);
                    if (typeof (this.$route.query.subCategoryIds) == "object" && this.$route.query.subCategoryIds) {
                        this.$route.query.subCategoryIds.forEach(ele => {
                            this.$store.commit('addSubCategoryId', ele);
                            this.$store.commit('checkedItem', ele);
                        });
                    } else {
                        this.$store.commit('addSubCategoryId', this.$route.query.subCategoryIds);
                        this.$store.commit('checkedItem', this.$route.query.subCategoryIds);
                    }
                }
                if (this.$route.query.otherId) {
                    if (typeof (this.$route.query.otherId) == "object") {
                        this.$route.query.otherId.forEach(ele => {
                            this.$store.commit('addOtherId', ele);
                            this.$store.commit('checkedFilter', ele);
                        });
                    } else {
                        this.$store.commit('addOtherId', this.$route.query.otherId);
                        this.$store.commit('checkedFilter', this.$route.query.otherId);
                    }
                }
                if (this.$route.query.search) {
                    this.$store.commit('getSearchhistory', this.$route.query.search);
                    this.$store.commit('showSearchTag', true);
                }
            }
            this.$store.dispatch('getProductDataList')
        }
    },
    mounted: function () {
        if (!this.$route.meta.lastRouter) {
            this.getFistState()
        }
    },
    destroyed() {
        this.$store.commit('addFpageData', []);
        this.$store.commit('changeTotal', 0);
    }
}
</script>

<style lang="scss" scoped>
.spage /deep/ .el-loading-mask {
    position: absolute;
    right: -30px;
}

.spage /deep/ .el-loading-spinner {
    position: fixed;
    top: 500px;
    left: 100px;
}

.reset {
    color: #409eff;
    margin-bottom: 10px;
    font-size: 16px;
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: -30px;
}

.result {
    padding-right: 30px;
}

.list {
    ul {
        li {
            margin-bottom: 20px;
            float: left;
            width: 198px;
            margin-right: 15px;
        }

        &::after {
            display: block;
            content: "";
            clear: both;
        }
    }
}

.el-tag {
    margin: 0 10px 10px 0;
    border: none;
    background: #2e79d0 !important;
    color: #fff;
}

.el-tag /deep/ .el-tag__close {
    color: #fff;
}

/deep/ .el-collapse {
    border: none;
}

/deep/ .el-collapse-item__header {
    border: none;
}

/deep/ .el-collapse-item__wrap {
    border: none;
}

.list-sm {
    height: 1700px;

    ul {
        height: 1700px;
        overflow: hidden;

        li {
            margin-bottom: 5px;
        }
    }
}

.list-mobile {
    height: 854px;
    margin-bottom: 10px;

    ul {
        width: 622px;
        height: 854px;
        overflow: hidden;

        li {
            float: left;
            width: 302px;
            height: 80px;
            margin-bottom: 6px;
            margin-right: 9px;
        }
    }
}
</style>
